export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/pc-403w-a8e477e03bf861582c090e5f53f772a9.webp";